import { create } from 'zustand';
import { Project, ProjectID } from '@shared/models/project.model';
import { DateTime } from 'luxon';
import { ProjectFolderId } from '@shared/models/folder.model';
export interface EditProjectFormData extends Pick<
  Project,
  'name' | 'description'
> {
  completed_at?: DateTime<boolean> | null;
}
export type EditProjectFocusField = keyof Pick<
  EditProjectFormData,
  'name' | 'description'
>;

export type ProjectType = 'template' | 'project';
export type DialogType = 'edit' | 'create' | 'duplicate';

interface EditProjectDialogState {
  type: ProjectType | undefined;
  mode: DialogType | undefined;
  id?: ProjectID;
  folderId?: ProjectFolderId;
  focusField?: EditProjectFocusField;

  /**
   * Project uploaded from file
   */
  project?: Project;

  set: (
    state: Pick<
      EditProjectDialogState,
      'type' | 'mode' | 'folderId' | 'id' | 'project' | 'focusField'
    >,
  ) => void;
  reset: () => void;
}

type EditProjectDialogData = Omit<EditProjectDialogState, 'set' | 'reset'>;
const defaultState: EditProjectDialogData = {
  id: undefined,
  folderId: undefined,
  focusField: 'name',
  type: undefined,
  mode: undefined,
  project: undefined,
};

export const useEditProjectDialogStore = create<EditProjectDialogState>(
  (set) => ({
    ...defaultState,
    set: (state) => set({ focusField: defaultState.focusField, ...state }),
    reset: () => set(defaultState),
  }),
);
